import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import ActiveProjects from "./ProjectTab/ActiveProjects";
import AppliedProjects from "./ProjectTab/AppliedProjects";
import CompletedProjects from "./ProjectTab/CompletedProjects";
import { useDispatch, useSelector } from "react-redux";
import { getMinePosts, getPostCounts } from "../../../../redux/posts/action";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import DeclinedProjects from "./ProjectTab/DeclinedProjects";
import CancelledProjects from "./ProjectTab/CancelledProjects";

export default function ManageProjects() {
  const { urlstate, setManageworkProjeteroute } = useRouteBaseStateContext();
  const [activeTab, setActiveTab] = useState("Appliedprojects");
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ posts: { postlistmine } }) => postlistmine,
  );
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostCounts(3));
  }, [dispatch]);

  useEffect(() => {
    if (urlstate?.manageworkprojetroute) {
      setActiveTab(urlstate?.manageworkprojetroute || "Appliedprojects");
    } else {
      setActiveTab("Appliedprojects");
    }
  }, [urlstate, urlstate?.manageworkprojetroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setManageworkProjeteroute(tab);
  };

  return (
    <div className="order-section manage-project">
      <div className="tab-sec">
        <div className="order-first">
          <h2>Manage Work</h2>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Appliedprojects" ? "active" : ""}`}
                onClick={() => handleTabClick("Appliedprojects")}
              >
                Applied projects ({postcounts?.applied})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Activeprojects" ? "active" : ""}`}
                onClick={() => handleTabClick("Activeprojects")}
              >
                Active projects ({postcounts?.active})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Completedprojects" ? "active" : ""}`}
                onClick={() => handleTabClick("Completedprojects")}
              >
                Completed projects ({postcounts?.completed})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "DeclinedProjects" ? "active" : ""}`}
                onClick={() => handleTabClick("DeclinedProjects")}
              >
                Declined offers ({postcounts?.declined})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "CancelledProjects" ? "active" : ""}`}
                onClick={() => handleTabClick("CancelledProjects")}
              >
                Cancelled projects ({postcounts?.cancelled})
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Appliedprojects" ? "active" : ""}`}
            id="Appliedprojects"
          >
            <AppliedProjects data={postlistmine} />
          </div>
          <div
            className={`tab-pane ${activeTab == "Activeprojects" ? "active" : ""}`}
            id="Activeprojects"
          >
            <ActiveProjects data={postlistmine} />
          </div>
          <div
            className={`tab-pane ${activeTab == "Completedprojects" ? "active" : ""}`}
            id="Completedprojects"
          >
            <CompletedProjects data={postlistmine} />
          </div>
          <div
            className={`tab-pane ${activeTab == "DeclinedProjects" ? "active" : ""}`}
            id="DeclinedProjects"
          >
            <DeclinedProjects data={postlistmine} />
          </div>
           <div
            className={`tab-pane ${activeTab == "CancelledProjects" ? "active" : ""}`}
            id="CancelledProjects"
          >
            <CancelledProjects data={postlistmine} />
          </div>
        </div>
      </div>
    </div>
  );
}
